import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './../assets/sass/views/Home.scss'
import { useTranslation } from 'react-i18next'
import { useDisconnect, useWeb3ModalAccount, useWeb3ModalProvider, useWeb3Modal } from '@web3modal/ethers/react'
import { BrowserProvider, Contract, ethers } from 'ethers'
import CONTRACT_DATA from '../abi'
import { getTicketPrice, preAddTicket, preEnterCompetition } from '../query/walletconnect/walletconnect.query'
import { useMutation } from 'react-query'
import cookies, { getUserToken } from '../cookies'
import redballimg from '../assets/images/red-ball-img.png'
import blueballimg from '../assets/images/blue-ball-img.png'
import bnb from '../assets/images/bnb.svg'
import { notify } from '../utils/notify'

export default function buyModal (props) {
  const { t } = useTranslation('global')
  const { open: openWallet } = useWeb3Modal()
  const [contractError, setContractError] = useState('')
  const [isDisable, setIsDisable] = useState(true)
  const [usdPrice, setUsdPrice] = useState(0)
  const [bnbPrice, setBnbPrice] = useState(0)
  const [noraPrice, setNoraPrice] = useState(0)
  const bnbCost = bnbPrice * 1
  const noraCost = noraPrice * 1
  const { disconnect } = useDisconnect()
  const connectDisconnectWallet = async () => {
    if (isConnected) {
      await disconnectWallet()
    } else {
      await openWallet()
    }
  }
  const filters = [{ id: 1, key: 'Number of consecutive numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of consecutive numbers in a combination. Example of a combination with 3 consecutive numbers: 7,18,19,20,31,36.' }, { id: 2, key: 'Number of even numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of even numbers in a combination. Example of a combination with 4 even numbers: 6,17,22,30,35,42.' }, { id: 3, key: 'Number of odd numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of odd numbers in a combination. Example of a combination with 2 odd numbers: 11,19,30,32,38,40.' }, { id: 4, key: 'Number of consecutive even numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of consecutive even numbers in a combination. Example of a combination with 3 consecutive even numbers: 3,15,22,24,26,34.' }, { id: 5, key: 'Number of consecutive odd numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of consecutive odd numbers in a combination. Example of a combination with 3 consecutive odd numbers:  8,17,19,21,34,40.' }, { id: 6, key: 'Number of prime numbers', min: 0, max: 6, tooltip: 'Select the maximum and minimum number of primes in a combination. A prime is a natural number greater than 1 that has no positive divisors other than 1 and itself. Example of a combination with 2 primes:  9,17,20,27,37,38. (17 and 37 are primes in the combination).' }]
  const advancedFilter = [{ id: 1, key: 'Average', min: 3, max: 40, tooltip: 'Select the minimum and the maximum value of the average of a combination. The average of a combination is the sum of all numbers in that combination divided by 6. Example of a combination having an average equal to 23.83: 2,13,20,31,36,41.' }, { id: 2, key: 'Length of the combination', min: 5, max: 41, tooltip: 'Select the minimum and the maximum value of the length of a combination. The length of a combination is the difference between the biggest and the smallest number in the combination. Example of a combination having a length of 39: 2,13,20,25,36,41.' }, { id: 3, key: 'Distance between two consecutive numbers', min: 1, max: 37, tooltip: 'Select the minimum and the maximum value of the distance between two consecutive numbers in a combination.  The distance between two consecutive numbers is the difference between the biggest and the smallest number among both. Example of a combination in which the minimum resp. the maximum distance between two consecutive number is equal to 3 resp. 15: 7,18,21,36,38,42 (distance 3 between 18-21 and distance 15 between 21-36).' }, { id: 4, key: 'Number of repetitions of a distance in a combination', min: 1, max: 5, tooltip: 'Select the minimum and the maximum number of repetitions of a distance in a combination. Example of a combination in which the distance 5 is repeated 3 times: 1,6,23,28,33,37.' }, { id: 5, key: 'Number of different distances in a combination', min: 1, max: 5, tooltip: 'Select the minimum and the maximum number of different distances between consecutive numbers in a combination. Example of a combination having at least 3 different distances: 1,6,14,23,33,42 (namely 5, 8 and 9).' }, { id: 6, key: 'Number of different units in the combination', min: 1, max: 6, tooltip: 'Select the minimum and the maximum number of different units in a combination. A unit is the last digit of a number (e.g. the unit of 12 is 2). Example of a combination having 4 different units: 8,12,27,33,37,38 (namely 8, 2, 7 and 3).' }, { id: 7, key: 'AC Value', min: 0, max: 10, tooltip: 'Select the minimum and the maximum number of the AC value of a combination. The so-called Arithmetic Complexity (AC value) measures the diversity of differences between numbers of a combination. The higher the value is, the more the numbers are mixed and randomly distributed. Example of a combination with AC Value 7: 2,7,18,29,36,41.' }]
  const blockFilter = [{ id: 1, numbers: [] }, { id: 2, numbers: [] }, { id: 3, numbers: [] }, { id: 4, numbers: [] }, { id: 5, numbers: [] }, { id: 6, numbers: [] }, { id: 7, numbers: [] }, { id: 8, numbers: [] }, { id: 9, numbers: [] }, { id: 10, numbers: [] }]

  const disconnectWallet = async () => {
    await disconnect()
    cookies.remove('sWalletAddress', { path: '/' })
    cookies.remove('userToken', { path: '/' })
    cookies.remove('address', { path: '/' })
    cookies.remove('chainId', { path: '/' })
    cookies.remove('isConnected', { path: '/' })
  }

  if (!props.showBuy) {
    return null
  }
  const competitionFormat = {}
  const updatecompetitionFormat = () => {
    props.nps && props.nps.length !== 0
      ? competitionFormat.noriParams = {
        ops: {
          op1: props.nps[0].isSelected,
          op2: (props.nps[2].isSelected && props.nps[2].selectedNum.length > 0),
          op3: (props.nps[4].isSelected && props.nps[4].selectedExcludeNum.length > 0),
          op4: props.nps[6].isSelected,
          op5: props.nps[1].isSelected && JSON.stringify(props.nps[1].selFilterCriteria) !== JSON.stringify(filters),
          op6: props.nps[3].isSelected && JSON.stringify(props.nps[3].selAdvanceFilterCriteria) !== JSON.stringify(advancedFilter),
          op7: props.nps[5].isSelected,
          op8: props.nps[7].isSelected && JSON.stringify(props.nps[7].selBlockWiseNum) !== JSON.stringify(blockFilter)
        },
        mns: props.nps[2].isSelected ? props.nps[2].selectedNum : [],
        qns: props.nps[4].isSelected ? props.nps[4].selectedExcludeNum : [],
        pns: props.nps[6].isSelected ? props.nps[6].selPriGrpNum : [],
        pd: props.nps[6].isSelected ? props.nps[6].lowPrio : 49,
        p1ns: props.nps[5].isSelected ? props.nps[5].quota : 6,
        p2nbs: props.nps[5].isSelected ? props.nps[5].selAppPartiNum : [],
        ftr: {
          nbMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[0].min : 0,
          nbMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[0].max : 6,
          evMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[1].min : 0,
          evMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[1].max : 6,
          odMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[2].min : 0,
          odMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[2].max : 6,
          evnbMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[3].min : 0,
          evnbMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[3].max : 6,
          odnbMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[4].min : 0,
          odnbMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[4].max : 6,
          pnMn: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[5].min : 0,
          pnMx: props.nps[1].isSelected ? props.nps[1].selFilterCriteria[5].max : 6
        },
        adftr: {
          avMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[0].min : props.nps[3].selAdvanceFilterCriteria[0].dmin,
          avMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[0].max : props.nps[3].selAdvanceFilterCriteria[0].dmax,
          clMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[1].min : props.nps[3].selAdvanceFilterCriteria[1].dmin,
          clMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[1].max : props.nps[3].selAdvanceFilterCriteria[1].dmax,
          spnbMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[2].min : props.nps[3].selAdvanceFilterCriteria[2].dmin,
          spnbMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[2].max : props.nps[3].selAdvanceFilterCriteria[2].dmax,
          speqMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[3].min : props.nps[3].selAdvanceFilterCriteria[3].dmin,
          speqMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[3].max : props.nps[3].selAdvanceFilterCriteria[3].dmax,
          spnqMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[4].min : props.nps[3].selAdvanceFilterCriteria[4].dmin,
          spnqMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[4].max : props.nps[3].selAdvanceFilterCriteria[4].dmax,
          unMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[5].min : props.nps[3].selAdvanceFilterCriteria[5].dmin,
          unMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[5].max : props.nps[3].selAdvanceFilterCriteria[5].dmax,
          acMn: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[6].min : props.nps[3].selAdvanceFilterCriteria[6].dmin,
          acMx: props.nps[3].isSelected ? props.nps[3].selAdvanceFilterCriteria[6].max : props.nps[3].selAdvanceFilterCriteria[6].dmax,
          tolMn: props.nps[3].isSelected ? props.nps[3].tolerance : 0
        },
        bq: props.nps[7].isSelected ? props.nps[7].numOfBlocks : 2,
        bcs: props.nps[7].isSelected
          ? [
              { n: props.nps[7].selBlockWiseNum[0].numbers },
              { n: props.nps[7].selBlockWiseNum[1].numbers },
              { n: props.nps[7].selBlockWiseNum[2].numbers },
              { n: props.nps[7].selBlockWiseNum[3].numbers },
              { n: props.nps[7].selBlockWiseNum[4].numbers },
              { n: props.nps[7].selBlockWiseNum[5].numbers },
              { n: props.nps[7].selBlockWiseNum[6].numbers },
              { n: props.nps[7].selBlockWiseNum[7].numbers },
              { n: props.nps[7].selBlockWiseNum[8].numbers },
              { n: props.nps[7].selBlockWiseNum[9].numbers }
            ]
          : [{ n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }, { n: [1, 2, 3, 4, 5, 6, 7, 9, 8, 10, 11, 12, 13, 14, 16, 15, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42] }],
        ncb: props.ncb ? props.ncb : null,
        competition: props.competition !== undefined && props.competition !== false
      }
      : competitionFormat.noriParams = null
    competitionFormat.noriDateStats = props.nds ? props.nds : null
    competitionFormat.noriPfactors = props.pFactor ? props.pFactor : null
  }
  updatecompetitionFormat()
  const ticketFormat = {}
  const updateTicketFormat = (ticket) => {
    const finalFormat = []
    for (let i = 0; i < ticket.length; i++) {
      const t = { n: ticket[i].selectedNo }
      if (ticket[i].totalSelectedNo === 6) finalFormat.push(t)
    }
    ticketFormat.ts = finalFormat

    ticketFormat.nps = competitionFormat.noriParams ? competitionFormat : null
    ticketFormat.goID = props.goId ? props.goId : null
    ticketFormat.cpt = props.competition !== undefined && props.competition !== false
  }
  if (props.nbrTicket) updateTicketFormat(props.ticket)
  const { isConnected } = useWeb3ModalAccount()
  const cookieIsConnected = isConnected || cookies.get('isConnected')
  const cookiesUserToken = getUserToken() ? getUserToken() : cookies.get('userToken')
  const { walletProvider } = useWeb3ModalProvider()
  const { mutate: preAddTicketMutation } = useMutation({
    mutationFn: (data) => {
      return preAddTicket(data)
    },
    // onSuccess: (data) => {
    //   console.log('Ticket added successfully', data?.data?.message)
    // },
    onError: (error) => {
      console.error('Error buying tickets:', error)
    }
  })
  const { mutate: preAddCompInfoMutation } = useMutation({
    mutationFn: (data) => {
      return preEnterCompetition(data)
    },
    // onSuccess: (data) => {
    //   console.log('Ticket added successfully', data?.data?.message)
    // },
    onError: (error) => {
      console.error('Error buying tickets:', error)
    }
  })
  const buyTickets = async (isBNB, noraTokens) => {
    try {
      if (!isConnected) {
        props.setShowBuy(false)
        await openWallet()
      } else {
        if (!cookieIsConnected) {
          setContractError('Please connect your wallet')
          return
        }
        const ethersProvider = new BrowserProvider(walletProvider)
        const signer = await ethersProvider.getSigner()
        // The Contract object
        const NORA642Contract = new Contract(
          CONTRACT_DATA.NORA642Address,
          CONTRACT_DATA.NORA642ABI,
          signer
        )
        setIsDisable(true)
        if (!isBNB) {
          const NORAContract = new Contract(
            CONTRACT_DATA.NORATOKENAddress,
            CONTRACT_DATA.NORAABI,
            signer
          )
          // check if the user has enough NORA tokens
          const noraBalance = await NORAContract.balanceOf(signer.getAddress())
          if (Number(noraBalance) < Number(ethers.parseEther(noraTokens.toString()))) {
            setContractError('Insufficient NORA balance')
            setIsDisable(false)
            return
          }
          const noraBalanceAllowance = await NORAContract.allowance(
            signer.getAddress(),
            CONTRACT_DATA.NORA642Address
          )
          if (Number(noraBalanceAllowance) < Number(ethers.parseEther(noraTokens.toString()))) {
            const tx = await NORAContract.approve(
              CONTRACT_DATA.NORA642Address,
              ethers.parseEther(noraTokens.toString())
            )

            // wait for the transaction to be mined
            await tx.wait()

            // check if the user has enough NORA tokens
            const noraBalanceAllowance = await NORAContract.allowance(
              signer.getAddress(),
              CONTRACT_DATA.NORA642Address
            )
            if (Number(noraBalanceAllowance) < Number(ethers.parseEther(noraTokens.toString()))) {
              setContractError('Insufficient NORA balance')
              setIsDisable(false)
              return
            }
          }
        } else {
          // check if the user has enough BNB
          const bnbBalance = await ethersProvider.getBalance(signer.getAddress())
          if (Number(bnbBalance) < Number(ethers.parseEther(bnbCost.toString()))) {
            setContractError('Insufficient BNB balance')
            setIsDisable(false)
            return
          }
        }

        // Estimate the gas
        const gasEstimate = await NORA642Contract.participate.estimateGas(
          isBNB,
          ethers.parseEther(noraTokens.toString()),
          {
            value: isBNB ? ethers.parseEther(bnbCost.toString()) : '0'
          }
        )

        const noraTokensStr = noraTokens.toString()
        const bnbCostStr = bnbCost.toString()

        // add the tickets data if there is one ticket or more
        if (props.nbrTicket) {
          ticketFormat.bpr = usdPrice
          ticketFormat.bnb = bnbCostStr
          ticketFormat.pib = isBNB
          preAddTicketMutation(ticketFormat)
        } else { // else statement ( proceed to competition only )
          competitionFormat.bpr = usdPrice
          competitionFormat.bnb = bnbCostStr
          competitionFormat.pib = isBNB
          preAddCompInfoMutation(competitionFormat)
        }

        // call the participate functions
        const sTransaction = await NORA642Contract.participate(isBNB, ethers.parseEther(noraTokensStr), {
          value: isBNB ? ethers.parseEther(bnbCostStr) : '0',
          gasLimit: gasEstimate
        })

        if (sTransaction?.hash) {
          notify('success', 'Game participation successful')
          props.setShowBuy(false)
        }
      }
    } catch (e) {
      console.log(e.message)
      const error = JSON.stringify(e)
      setContractError(JSON.parse(error)?.reason)
      setIsDisable(false)
    }
  }

  useEffect(() => {
    if (props.showBuy) {
      const fetchData = async () => {
        try {
          const basePrice = props.competition ? props.nbrTicket * 0.5 + 1 : props.nbrTicket * 0.5
          const response = await getTicketPrice({ nUSDPrice: basePrice })
          setUsdPrice(basePrice)
          setBnbPrice(response.data?.data?.nBNBPrice)
          setNoraPrice(response.data?.data?.nNORAPrice)
          setIsDisable(false)
        } catch (error) {
          setContractError(error?.response?.data?.message)
          if (error?.response?.status === 401) {
            disconnectWallet()
          }
          console.error('Error fetching ticket price:', error)
        }
      }
      fetchData()
    }
  }, [props.showBuy])
  return (
    <>
      {cookieIsConnected
        ? cookiesUserToken
          ? <div className='modalBuy'>
          <div className='transparent' onClick={() => props.setShowBuy(false)}></div>
          <div className='content'>
            <h1 className='h1'>{t('component.buyModal.title')}</h1>
            {props.nbrTicket !== 0
              ? <div className="total">
                {t('component.buyModal.totalTicket')} {props.nbrTicket}
              </div>
              : null
            }
            <div className="competition">
              {t('component.buyModal.noriCompet')} {props.competition ? t('global.yes') : t('global.no')}
            </div>
            <div className="buy">
              <button className='button' onClick={() => buyTickets(true, 0)} disabled={isDisable}>{t('component.buyModal.bnbBuy')} <br /> <span>{bnbCost.toFixed(9)} BNB</span> </button>
              <button className='button' onClick={() => buyTickets(false, noraCost.toFixed(9))} disabled={isDisable}>{t('component.buyModal.noraBuy')}<br /> <span>{noraCost.toFixed(9)} NORA</span> </button>
              <div><p className="error-msg show">{contractError || ''}</p></div>
              <button className='button cancel' onClick={() => props.setShowBuy(false)}>{t('component.buyModal.cancel')}</button>
            </div>
          </div>
        </div>
          : <div>
            {(() => {
              notify('error', t('global.connectError'))
              disconnectWallet()
            })()}
          </div>
        : <div className='modalBuyConnect' onClick={() => props.setShowBuy(false)}>
          <div className="notConnectedBG">
            <img className='red' src={redballimg} alt="Ball" />
            <img className='blue' src={blueballimg} alt="Ball" />
          <div>
          <div className='message'>
            <h3>{t('global.infoConnect')}</h3>
            <button className='connect' onClick={() => connectDisconnectWallet()}> <img src={bnb} alt='BNB' /> {t('connectWallet')}</button>
            <button className='cancel' onClick={() => props.setShowBuy(false)}> {t('global.cancel')} </button>
          </div>
        </div>
      </div>
    </div>}
    </>
  )
}

buyModal.PropTypes = {
  showBuy: PropTypes.bool,
  setShowBuy: PropTypes.func.isRequired,

  nbrTicket: PropTypes.number,
  competition: PropTypes.bool,

  ticket: PropTypes.array,
  nps: PropTypes.array,
  nds: PropTypes.object,
  pFactor: PropTypes.array,
  ncb: PropTypes.number
}
